import { Component } from '@angular/core';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent {
  settingJson:any
  menu:any="20px";
  id:any
    constructor(private SettingsService:SettingsService,private router:Router,private route:ActivatedRoute,private location:Location
      ){
     this.SettingsService.ConfigJson().then((data:any) => {
        this.settingJson=data["menu"]
       })
       .catch((error:any) => {
       });
       this.route.queryParams.subscribe(params => {
        let data:any
        data=params
        this.id=this.decodeTransformedcode(data.id)
       console.log(this.id)
       // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
        
        
      
          });
    }
    transformcode(email: string): string {
      let result = '';
    
      for (let i = 0; i < email.length; i++) {
        const char = email.charCodeAt(i);
        result += char.toString(16); // Convert the character code to a hexadecimal string
      }
    
      return result;
    }
    decodeTransformedcode(encodedEmail: string): string {
      let result = '';
    
      for (let i = 0; i < encodedEmail.length; i += 2) {
        const hexChar = encodedEmail.slice(i, i + 2);
        const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
        result += String.fromCharCode(charCode);
      }
    
      return result;
    }
    OnClickLink(subMenu:any){
      if(subMenu==="Air Configuration"){
     // this.router.navigate(["/app/Air-config"]);
         window.location.href="/app/Air-config?id="+this.transformcode(this.id)
}else if(subMenu==="Hotel Configuration"){
  window.location.href="/app/Hotel-config?id="+this.transformcode(this.id)
}
      else if(subMenu==="User"){
        this.router.navigate(["/app/User-config"]);

      }
      else if(subMenu==="Payment Configuration"){
        window.location.href="/app/payment-config?id="+this.transformcode(this.id)+"&type="+this.transformcode('c')

      }
      else if(subMenu==="Reporting Configuration"){
       window.location.href="/app/reporting-config?id="+this.transformcode(this.id)

      }
  
    }
    backClick(){
     window.location.href="/app/Users"
    }
}
